import React, { Component } from 'react';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import { CHANNEL_COLOR_SET, SENTIMENT_COLOR_SET } from '../../../../config/ColorSet';
import { Channel_CODE_SET } from '../../../../config/CgmCodeSet';
import { SENTIMENT_SET } from '../../../../config/SentimentSet';
import GraphModal from '../../modal/GraphModal';


class LineForReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // showWindowPortal: false,
      clickedData: null,
      showModal: false
    }
  }

  componentDidMount() {
    const data = this.props.data;
    const timeunit = this.props.timeunit;
    const datatype = this.props.datatype;
    const excelExportFunc = this.props.excelExportFunc;
    const reportType = this.props.reportType;
    const reportName = this.props.reportName;
    console.log(data)
    let chart = null;

    switch (reportType) {
      case "volume": {
        this.createVolumeLineForReport(chart, reportName, data, timeunit, datatype, excelExportFunc);
        break;
      }
      case "sentiment": {
        this.createSentimentLineForReport(chart, reportName, data, timeunit, datatype, excelExportFunc);
        break;
      }
      default:
        break;
    }
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose()
    };
  }

  componentDidUpdate(prevProps) {
    if ((this.props.data != null) && (prevProps.data !== this.props.data)) {
      if (this.chart) {
        this.chart.dispose();
      }
      const data = this.props.data;
      const timeunit = this.props.timeunit;
      const datatype = this.props.datatype;
      const excelExportFunc = this.props.excelExportFunc;
      const reportType = this.props.reportType;
      const reportName = this.props.reportName;

      let chart = null;

      switch (reportType) {
        case "volume": {
          this.createVolumeLineForReport(chart, reportName, data, timeunit, datatype, excelExportFunc);
          break;
        }
        case "sentiment": {
          this.createSentimentLineForReport(chart, reportName, data, timeunit, datatype, excelExportFunc);
          break;
        }
        default:
          break;
      }
    }
  }

  createBuzzlistWindow = (data) => {
    this.setState(state => ({
      ...state,
      // showWindowPortal: !state.showWindowPortal,
      clickedData: data,
      showModal: true
    }));

    let retJSON = {
      sub_query_type: this.props.subQueryType,
      retwit: this.props.reTweet == "true",
      reportType: "buzzlist",
      name: "결과_미리보기",
      channel: this.props.channels,
      query: [this.props.mainQuery, ...this.props.subQuery]
    }
    if (data.hasOwnProperty('end_date')) {
      retJSON.dateRange = [data.date.replace(/\-/g, ""), data.end_date.replace(/\-/g, "")]
    }
    else {
      retJSON.dateRange = [data.date.replace(/\-/g, ""), data.date.replace(/\-/g, "")]
    }
  }

  closeBuzzlistWindow = () => {
    this.setState(state => ({
      ...state,
      // showWindowPortal: !state.showWindowPortal,
      showModal: false
    }));
  }

  createVolumeLineForReport = (chart, reportName, dataSet, timeunit, datatype, excelExportFunc) => {
    chart = am4core.create(this.lineChart, am4charts.XYChart);
    am4core.useTheme(am4themes_animated);

    chart.data = dataSet.data;
    console.log(dataSet.data)
    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

    valueAxis.min = 0;

    dateAxis.renderer.minGridDistance = 20;
    dateAxis.renderer.labels.template.rotation = 90;
    dateAxis.renderer.labels.template.horizontalCenter = "left";
    dateAxis.renderer.labels.template.verticalCenter = "middle";


    switch (timeunit) {
      case "daily": {
        dateAxis.dateFormats.setKey("day", "yyyy-MM-dd");
        dateAxis.periodChangeDateFormats.setKey("day", "yyyy-MM-dd");
        dateAxis.baseInterval = { timeUnit: "day", count: 1 };
        break;
      }
      case "weekly": {
        dateAxis.dateFormats.setKey("day", "yyyy-MM-dd");
        dateAxis.periodChangeDateFormats.setKey("day", "yyyy-MM-dd");
        dateAxis.baseInterval = { timeUnit: "day", count: 1 };
        dateAxis.skipEmptyPeriods = true;
        break;
      }
      case "monthly": {
        dateAxis.dateFormats.setKey("month", "yyyy-MM");
        dateAxis.periodChangeDateFormats.setKey("month", "yyyy-MM");

        dateAxis.baseInterval = { timeUnit: "month", count: 1 };
        break;
      }
      default:
        break;
    }

    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.baseGrid.disabled = true;
    dateAxis.renderer.grid.template.disabled = true;

    if (datatype == 'numeric') {
      valueAxis.renderer.labels.template.adapter.add("text", function (text, target) {
        if (typeof (text) == "string") {
          let dotIndex = text.indexOf('.');
          if (dotIndex == -1) {
            return text;
          }
          else if (dotIndex != -1 && text[dotIndex + 1] == '0') {
            return text.slice(0, dotIndex);
          }
        }
      });
    }
    else if (datatype == 'percentage') {
      valueAxis.calculateTotals = true;
      valueAxis.min = 0;
      valueAxis.max = 100;
    }

    dataSet.channel.forEach((item) => {
      let name = dataSet.query.join(' & ');
      chart.series.push(this.createVolumeSeries(`${name} (${Channel_CODE_SET[item]})`, item, timeunit, datatype))
    })
    chart.legend = new am4charts.Legend();

    chart.cursor = new am4charts.XYCursor();
    dateAxis.cursorTooltipEnabled = false;
    valueAxis.cursorTooltipEnabled = false;
    chart.cursor.lineX.disabled = true;
    chart.cursor.lineY.disabled = true;
    chart.cursor.behavior = "none";

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.menu.container = document.getElementById("export-container");

    let today = new Date();
    chart.exporting.filePrefix = `${reportName}_${today.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}`;
    chart.exporting.useWebFonts = false;
    chart.exporting.menu.items = [
      {
        "label": "...",
        "menu": [
          {
            "type": "png",
            "label": "PNG"
          },
          {
            "type": "jpg",
            "label": "JPG"
          },
          {
            "type": "custom",
            "label": "Excel",
            "options": {
              callback: excelExportFunc
            }
          }
        ]
      }
    ]
    this.chart = chart;
  }

  //value => channel
  createVolumeSeries = (name, value, timeunit, datatype) => {
    let retSeries = new am4charts.LineSeries();
    retSeries.dataFields.valueY = value;
    retSeries.dataFields.dateX = "date";
    retSeries.name = name;

    retSeries.strokeWidth = 5;
    retSeries.stroke = am4core.color(CHANNEL_COLOR_SET[value]);
    // retSeries.minBulletDistance = 1000;
    retSeries.minBulletDistance = 10;


    let retBullet = retSeries.bullets.push(new am4charts.CircleBullet());
    retBullet.circle.fill = am4core.color(CHANNEL_COLOR_SET[value]);
    retBullet.circle.radius = 4;
    retBullet.events.on("hit", (ev) => {
      this.createBuzzlistWindow(ev.target.dataItem.dataContext);
    })
    retSeries.tooltip.pointerOrientation = "up";

    if (datatype == 'numeric') {
      switch (timeunit) {
        case "daily": {
          retSeries.tooltipText = `${name} ({dateX}): [bold]{valueY}[/]`
          break;
        }
        case "weekly": {
          retSeries.tooltipText = `${name} ({dateX}~{end_date}): [bold]{valueY}[/]`
          break;
        }
        case "monthly": {
          retSeries.tooltipText = `${name} ({dateX}~{end_date}): [bold]{valueY}[/]`
          break;
        }
        default:
          break;
      }
    }
    else if (datatype == 'percentage') {
      switch (timeunit) {
        case "daily": {
          retSeries.tooltipText = `${name} ({dateX}): [bold]{valueY.totalPercent.formatNumber('#.#')}[/]`
          break;
        }
        case "weekly": {
          retSeries.tooltipText = `${name} ({dateX}~{end_date}): [bold]{valueY.totalPercent.formatNumber('#.#')}[/]`
          break;
        }
        case "monthly": {
          retSeries.tooltipText = `${name} ({dateX}~{end_date}): [bold]{valueY.totalPercent.formatNumber('#.#')}[/]`
          break;
        }
        default:
          break;
      }
    }
    retSeries.tooltip.getFillFromObject = false;
    retSeries.tooltip.background.fill = am4core.color(CHANNEL_COLOR_SET[value]);
    // retSeries.tooltip.label.fill = am4core.color("#000000");

    if (datatype == 'numeric') {

    }
    else if (datatype == 'percentage') {
      retSeries.dataFields.valueYShow = 'totalPercent';
    }


    return retSeries;
  }

  createSentimentLineForReport = (chart, reportName, dataSet, timeunit, datatype, excelExportFunc) => {
    chart = am4core.create(this.lineChart, am4charts.XYChart);
    am4core.useTheme(am4themes_animated);

    chart.data = dataSet.data;

    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

    dateAxis.renderer.minGridDistance = 20;
    dateAxis.renderer.labels.template.rotation = 90;
    dateAxis.renderer.labels.template.horizontalCenter = "left";
    dateAxis.renderer.labels.template.verticalCenter = "middle";


    switch (timeunit) {
      case "daily": {
        dateAxis.dateFormats.setKey("day", "yyyy-MM-dd");
        dateAxis.periodChangeDateFormats.setKey("day", "yyyy-MM-dd");
        dateAxis.baseInterval = { timeUnit: "day", count: 1 };
        break;
      }
      case "weekly": {
        dateAxis.dateFormats.setKey("day", "yyyy-MM-dd");
        dateAxis.periodChangeDateFormats.setKey("day", "yyyy-MM-dd");
        dateAxis.baseInterval = { timeUnit: "day", count: 1 };
        dateAxis.skipEmptyPeriods = true;
        break;
      }
      case "monthly": {
        dateAxis.dateFormats.setKey("month", "yyyy-MM");
        dateAxis.periodChangeDateFormats.setKey("month", "yyyy-MM");

        dateAxis.baseInterval = { timeUnit: "month", count: 1 };
        break;
      }
      default:
        break;
    }

    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.baseGrid.disabled = true;
    dateAxis.renderer.grid.template.disabled = true;

    if (datatype == 'numeric') {
      valueAxis.renderer.labels.template.adapter.add("text", function (text, target) {
        if (typeof (text) == "string") {
          let dotIndex = text.indexOf('.');
          if (dotIndex == -1) {
            return text;
          }
          else if (dotIndex != -1 && text[dotIndex + 1] == '0') {
            return text.slice(0, dotIndex);
          }
        }
      });
    }
    else if (datatype == 'percentage') {
      valueAxis.calculateTotals = true;
      valueAxis.min = 0;
      valueAxis.max = 100;
    }

    ['positive', 'negative', 'mix', 'neutral'].forEach((item) => {
      let name = dataSet.query.join(' & ');
      chart.series.push(this.createSentimentSeries(`${name} (${Channel_CODE_SET[dataSet.channel]}) (${SENTIMENT_SET[item]})`, item, timeunit, datatype))
    })

    chart.legend = new am4charts.Legend();

    chart.cursor = new am4charts.XYCursor();
    dateAxis.cursorTooltipEnabled = false;
    valueAxis.cursorTooltipEnabled = false;
    chart.cursor.lineX.disabled = true;
    chart.cursor.lineY.disabled = true;
    chart.cursor.behavior = "none";

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.menu.container = document.getElementById("export-container");

    let today = new Date();
    chart.exporting.filePrefix = `${reportName}_${today.toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" }).replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}`;
    chart.exporting.useWebFonts = false;
    chart.exporting.menu.items = [
      {
        "label": "...",
        "menu": [
          {
            "type": "png",
            "label": "PNG"
          },
          {
            "type": "jpg",
            "label": "JPG"
          },
          {
            "type": "custom",
            "label": "Excel",
            "options": {
              callback: excelExportFunc
            }
          }
        ]
      }
    ]
    this.chart = chart;
  }

  //value => channel
  createSentimentSeries = (name, value, timeunit, datatype) => {
    let retSeries = new am4charts.LineSeries();
    retSeries.dataFields.valueY = value;
    retSeries.dataFields.dateX = "date";
    retSeries.name = name;

    // retSeries.strokeWidth = 3;
    // retSeries.stroke = am4core.color(SENTIMENT_COLOR_SET[value]);
    // retSeries.minBulletDistance = 1000;

    // let retBullet = retSeries.bullets.push(new am4charts.CircleBullet());
    // retBullet.circle.fill = am4core.color(SENTIMENT_COLOR_SET[value]);

    retSeries.strokeWidth = 5;
    retSeries.stroke = am4core.color(SENTIMENT_COLOR_SET[value]);
    // retSeries.minBulletDistance = 1000;
    retSeries.minBulletDistance = 10;

    let retBullet = retSeries.bullets.push(new am4charts.CircleBullet());
    retBullet.circle.fill = am4core.color(SENTIMENT_COLOR_SET[value]);
    retBullet.circle.radius = 4;
    retBullet.events.on("hit", (ev) => {
      this.createBuzzlistWindow(ev.target.dataItem.dataContext);
    })
    retSeries.tooltip.pointerOrientation = "up";


    if (datatype == 'numeric') {
      switch (timeunit) {
        case "daily": {
          retSeries.tooltipText = `${name} ({dateX}): [bold]{valueY}[/]`
          break;
        }
        case "weekly": {
          retSeries.tooltipText = `${name} ({dateX}~{end_date}): [bold]{valueY}[/]`
          break;
        }
        case "monthly": {
          retSeries.tooltipText = `${name} ({dateX}~{end_date}): [bold]{valueY}[/]`
          break;
        }
        default:
          break;
      }
    }
    else if (datatype == 'percentage') {
      switch (timeunit) {
        case "daily": {
          retSeries.tooltipText = `${name} ({dateX}): [bold]{valueY.totalPercent.formatNumber('#.#')}[/]`
          break;
        }
        case "weekly": {
          retSeries.tooltipText = `${name} ({dateX}~{end_date}): [bold]{valueY.totalPercent.formatNumber('#.#')}[/]`
          break;
        }
        case "monthly": {
          retSeries.tooltipText = `${name} ({dateX}~{end_date}): [bold]{valueY.totalPercent.formatNumber('#.#')}[/]`
          break;
        }
        default:
          break;
      }
    }
    retSeries.tooltip.getFillFromObject = false;
    retSeries.tooltip.background.fill = am4core.color(SENTIMENT_COLOR_SET[value]);
    // retSeries.tooltip.label.fill = am4core.color("#fff");

    if (datatype == 'numeric') {

    }
    else if (datatype == 'percentage') {
      retSeries.dataFields.valueYShow = 'totalPercent';
    }


    return retSeries;
  }



  render() {
    return (
      <div>
        <div id="export-container" style={{ position: "relative", minHeight: "30px" }} />
        <div id="line" ref={ref => (this.lineChart = ref)} style={{ width: this.props.width, height: this.props.height }}></div>
        <GraphModal showModal={this.state.showModal} closeBuzzlistWindow={this.closeBuzzlistWindow}
          clickedData={this.state.clickedData} reportType={this.props.reportType} mainQuery={this.props.mainQuery} subQuery={this.props.subQuery} subQueryType={this.props.subQueryType} reTweet={this.props.reTweet} channels={this.props.channels}
          userRole={this.props.userRole}
        />
      </div>
    )
  }
}

export default LineForReport;